export const LxgRecipe = {
    recipeList: [
        {
            code: 'xcpy',
            name: "星垂平野",
            recipeOptional: [
                {
                    code: 4983,
                    name: "星垂平野 会心+2%"
                },
                {
                    code: 4984,
                    name: "星垂平野 会心+3%"
                },
                {
                    code: 4985,
                    name: "星垂平野 会心+4%"
                },
                {
                    code: 4986,
                    name: "星垂平野 伤害+3%"
                },
                {
                    code: 4987,
                    name: "星垂平野 伤害+4%"
                },
                {
                    code: 4988,
                    name: "星垂平野 伤害+5%"
                }
            ],
            selected:[4985,4986,4987,4988],
        },
        {
            code: 'jghl',
            name: "金戈回澜",
            recipeOptional: [
                {
                    code: 4994,
                    name: "金戈回澜 会心+3%"
                },
                {
                    code: 4995,
                    name: "金戈回澜 会心+4%"
                },
                {
                    code: 4996,
                    name: "金戈回澜 伤害+4%"
                },
                {
                    code: 4997,
                    name: "金戈回澜 伤害+5%"
                }
            ],
            selected:[4996, 4997],
        },
        {
            code: 'ltl',
            name: "乱天狼",
            recipeOptional: [
                {
                    code: 5044,
                    name: "乱天狼 会心+3%"
                },
                {
                    code: 5045,
                    name: "乱天狼 会心+4%"
                },
                {
                    code: 5001,
                    name: "乱天狼 伤害+4%"
                },
                {
                    code: 5002,
                    name: "乱天狼 伤害+5%"
                }
            ],
            selected:[5001,5002],
        },
        {
            code: 'jhh',
            name: "寂洪荒",
            recipeOptional: [
                {
                    code: 5004,
                    name: "寂洪荒 伤害+3%"
                },
                {
                    code: 5005,
                    name: "寂洪荒 伤害+4%"
                },
                {
                    code: 5006,
                    name: "寂洪荒 伤害+5%"
                }
            ],
            selected:[5004, 5005, 5006],
        },
        {
            code: 'yfl',
            name: "隐风雷",
            recipeOptional: [
                {
                    code: 5063,
                    name: "隐风雷 会心+2%"
                },
                {
                    code: 5064,
                    name: "隐风雷 会心+3%"
                },
                {
                    code: 5065,
                    name: "隐风雷 会心+4%"
                },
                {
                    code: 5069,
                    name: "隐风雷 伤害+3%"
                },
                {
                    code: 5070,
                    name: "隐风雷 伤害+4%"
                },
                {
                    code: 5071,
                    name: "隐风雷 伤害+5%"
                }
            ],
            selected:[5065,5069,5070,5071],
        },
        {
            code: 'zwc',
            name: "斩无常",
            recipeOptional: [
                {
                    code: 5046,
                    name: "斩无常 会心+3%"
                },
                {
                    code: 5047,
                    name: "斩无常 会心+4%"
                },
                {
                    code: 5010,
                    name: "斩无常 伤害+4%"
                },
                {
                    code: 5011,
                    name: "斩无常 伤害+5%"
                }
            ],
            selected:[5010,5011],
        },
        {
            code: 'ymky',
            name: "幽冥窥月",
            recipeOptional: [
                {
                    code: 5018,
                    name: "幽冥窥月 会心+2%"
                },
                {
                    code: 5019,
                    name: "幽冥窥月 会心+3%"
                },
                {
                    code: 5050,
                    name: "幽冥窥月 伤害+5%"
                },
                {
                    code: 5051,
                    name: "幽冥窥月 伤害+5%"
                }
            ],
            selected:[5019,5050,5051],
        },
    ]
}